import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Button from '../../components/ui/Button';
import { notFound } from '../../content/not-found';
import { trackClick } from '../../firebase/analytics';
import './not-found.css';

export default function NotFound() {
  return (
    <main id="main" className="kds-not-found" tabIndex={-1}>
      <Helmet>
        <title>{notFound.title}</title>
        <meta name="description" content={notFound.description} />
        <meta name="robots" content="noindex" />
      </Helmet>

      <header className="kds-not-found-header">
        <Link to="/" className="kds-not-found-brand kds-title-md" onClick={trackClick('not_found', 'brand_home_link')}>
          keval.io<span aria-hidden="true"> /</span>
        </Link>
        <span className="kds-body-sm kds-muted">An unplanned detour</span>
      </header>

      <div className="kds-not-found-content kds-stack">
        {/* A tiny map hidden in the zero. All motion settles; no timers or loops. */}
        <div className="kds-not-found-art" aria-hidden="true">
          <svg viewBox="0 0 624 300" fill="none" focusable="false">
            <path className="kds-not-found-trail" d="M24 240C75 282 152 277 202 240S262 185 232 166 187 188 220 210 331 233 388 159 455 80 492 81 545 82 582 40" strokeWidth="1.5" strokeDasharray="4 7" strokeLinecap="round" />
            <circle className="kds-not-found-origin" cx="24" cy="240" r="4" />

            <g className="kds-not-found-numerals" fillRule="evenodd">
              <path d="M138 53 51 167v33h87v41h43v-41h25v-36h-25V53Zm0 56v55H95Z" />
              <path d="M501 53 414 167v33h87v41h43v-41h25v-36h-25V53Zm0 56v55h-43Z" />
            </g>

            <g className="kds-not-found-compass">
              <ellipse className="kds-not-found-zero" cx="310" cy="147" rx="74" ry="94" strokeWidth="32" />
              <path className="kds-not-found-ticks" d="M310 76v9m0 124v9m-52-71h9m86 0h9" strokeWidth="2" strokeLinecap="round" />
              <g className="kds-not-found-bearing">
                <g className="kds-not-found-needle">
                  <path className="kds-not-found-needle-north" d="m310 99 16 48-16-7-16 7Z" />
                  <path className="kds-not-found-needle-south" d="m310 195-16-48 16 7 16-7Z" />
                  <circle className="kds-not-found-origin" cx="310" cy="147" r="4" />
                </g>
              </g>
            </g>

            <g className="kds-not-found-destination">
              <path d="m576 34 12 12m0-12-12 12" strokeWidth="2" strokeLinecap="round" />
            </g>
          </svg>
          <span className="kds-not-found-note kds-body-sm kds-muted">you are here. ish.</span>
        </div>

        <div className="kds-not-found-copy kds-stack">
          <p className="kds-eyebrow kds-eyebrow--accent">{notFound.eyebrow}</p>
          <h1 className="kds-display-lg">{notFound.heading}</h1>
          <p className="kds-body-lg kds-muted">{notFound.description}</p>
        </div>

        <nav className="kds-not-found-actions kds-cluster" aria-label="Find your way">
          <Button to="/" className="kds-not-found-home" onClick={trackClick('not_found', 'home_link')}>
            <span aria-hidden="true">←</span> Back to home
          </Button>
          <Button to="/apps" variant="tonal" onClick={trackClick('not_found', 'apps_link')}>
            Explore portfolio <span aria-hidden="true">↗</span>
          </Button>
        </nav>

        <p className="kds-not-found-footnote kds-body-sm kds-muted">
          The page is missing. The developer isn’t.{' '}
          <Link to="/cv" className="kds-not-found-cv kds-link-underline" onClick={trackClick('not_found', 'cv_link')}>View my CV</Link>
        </p>
      </div>
    </main>
  );
}
